import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';
import Globalize from 'globalize';
import 'jquery-hoverintent';
import 'jquery-slimscroll';
import app from '../../app';
import TransferModalController from './TransferModalController';

export default Backbone.View.extend({
    events: {
        'click [name="shoppingCartOrder"]': 'onOrderClick',
        'click #transfer-shopping-cart': 'onTransferClick',
        'focus #header-shoppingCartLink': 'tabFocusShoppingCart',
        'blur .shopping-cart-details.header-status-list .footer a': 'tabBlurShoppingCart'
    },

    initialize: function () {
        app.getShoppingCart().on('all', this.refresh, this);
        this.refresh();

        this.initHover();
        this.initScrolling();

        this.initKeyboardShortcuts();

        this.initCustomerOrderModal(app.getShoppingCart().id);
        this.initTransferModal();

        if (window.POne.pageModel.userProfile.portalCustomer.customerRefNo) {
            this.initCustomerOrderModal(app.getShoppingCart().id);
        }
    },

    initTransferModal: function () {
        this.transferModal = $.Mustache.jQ('modal', {
            id: 'transfer-modal',
            title: Globalize.localize('shoppingCart.transfer.title')
        });
        this.transferModal.removeClass('modal-lg');

        // add content
        const form = $.Mustache.jQ('transfer-modal-template', { id: app.getShoppingCart().id });
        this.transferModal.find('.modal-body').append(form);

        // add button to footer
        const submitButton = form.find('#submitTransfer');
        submitButton.prependTo(this.transferModal.find('.modal-footer'));
        form.find('.form-actions').remove();

        // add modal to DOM
        $('body').append(this.transferModal);
        // Add controller
        new TransferModalController({
            el: this.transferModal
        });
    },

    onTransferClick: function () {
        this.transferModal.modal('show');
        this.onModal();
    },

    refresh: function () {
        if (_.isUndefined(this.details)) {
            this.details = $.Mustache.jQ('header-shopping-cart');
        }

        const list = this.details.find('ul');

        list.children('li').remove();

        app.getShoppingCart().get('shoppingCartItems')
            .each((shoppingCartItem) => {
                const description = (shoppingCartItem.get('descriptionShort') === null) ?
                    '' :
                    shoppingCartItem.get('descriptionShort');
                const shortenedDescription = description.substr(0, 28) + (description.length > 28 ? '...' : '');

                const decodedDescription = $('<div/>').html(description);
                const decodedShortDescription = $('<div/>').html(shortenedDescription);

                const catalogItem = shoppingCartItem.get('catalogItem');
                // TODO - if catalog item is null
                const imageUrl = catalogItem.getImageUrl(70);

                // Check if the Shopping-cart item is part of core assortment
                let coreAssortment = false;

                $(catalogItem.get('customFields')).each((field, elem) => {
                    if (elem.name === 'Kernsortiment') {
                        coreAssortment = true;
                    }
                });

                const data = {
                    shoppingCartId: app.getShoppingCart().id,
                    shoppingCartItemId: shoppingCartItem.id,
                    description: decodedDescription.text(),
                    imageUrl: imageUrl,
                    shortenedDescription: decodedShortDescription.text(),
                    price: Globalize.format(shoppingCartItem.get('price'), 'c'),
                    quantity: Globalize.format(shoppingCartItem.get('quantity'), 'n')
                };
                // Based on the boolean decide to add a core assortment item or normal
                if (coreAssortment) {
                    list.append($.Mustache.jQ('header-shopping-cart-item-coreAssortment', data));
                } else {
                    list.append($.Mustache.jQ('header-shopping-cart-item', data));
                }

            });

        if (this.$el.find('.shopping-cart-details').length > 0) {
            const shoppingCartSize = app.getShoppingCart()
                .get('shoppingCartItems')
                .size();
            this.$el.find('.size').text(`${shoppingCartSize} ${Globalize.localize('products')}`);
            this.$el.find('.total-price').text(Globalize.format(app.getShoppingCart().get('totalPrice'), 'c'));
        } else {
            this.$el.append(this.details);
        }

        this.updateScrolling();

        this.trigger('refresh');
    },


    initCustomerOrderModal: function (shoppingCartId) {
        this.customerOrderModal = $.Mustache.jQ('modal', {
            id: 'customer-order-number',
            title: Globalize.localize('shoppingCart.customerOrderNumber.title')
        });
        this.customerOrderModal.attr('tabindex', -1);
        this.customerOrderModal.removeClass('modal-lg');

        // add content
        const form = $('<form>').attr({
            class: 'form-horizontal',
            method: 'POST',
            action: `${window.POne.config.contextPath}/shopping_carts/${shoppingCartId}/submit?submitShoppingCart=1`
        });

        form.append($.Mustache.jQ('customer-order-number'), {});

        //append all to modal
        this.customerOrderModal.find('.modal-body').append(form);

        // move button to modal footer
        const submitButton = form.find('#submitCustomerOrderNumber');
        submitButton.click(_.bind(function () {
            form.submit();
        }, this));
        submitButton.prependTo(this.customerOrderModal.find('.modal-footer'));
        form.find('.form-actions').remove();

        // add modal to DOM
        $('body').append(this.customerOrderModal);
        this.onModal();
    },

    initHover: function () {
        if (app.getShoppingCart().get('shoppingCartItems').length > 0) {
            this.$el.hoverIntent({
                over: () => this.showDetails(),
                out: () => this.hideDetails(),
                timeout: 500
            });
        } else {
            this.$el.hover(
                () => this.showDetails(),
                () => this.hideDetails()
            );
        }
    },

    initScrolling: function () {
        this.details.find('ul').slimScroll({
            height: `${this.getScrollingHeight()}px`
        });

        $(window).scroll(_.bind(this.updateScrolling, this));
        $(window).resize(_.bind(this.updateScrolling, this));
    },

    initKeyboardShortcuts: function () {
        //$(document).bind('keydown', 'shift+w', _.bind(this.onKeyOpenShoppingCart, this));
    },

    updateScrolling: function () {
        const height = `${this.getScrollingHeight()}px`;
        this.details.find('ul').css('height', height);
        this.details.children('.slimScrollDiv').css('height', height);
        this.details.children('.slimScrollDiv').attr('role', 'scrollbar');
    },

    onKeyOpenShoppingCart: function () {
        window.location.href = this.$el.children('a').attr('href');
    },

    getScrollingHeight: function () {
        const listSize = this.details.find('ul > li').length;
        const maxVisibleListSize = (listSize > 6) ? 6.5 : listSize;

        const listItemHeight = 70;
        let height = (listItemHeight * maxVisibleListSize); // 6 1/2 shopping cart items at max visible
        const availableHeight = $(window).height() - (this.details.offset().top - $(window).scrollTop()) - 200; // 200px to be on the save side

        while (height > availableHeight) {
            height = height - listItemHeight;
        }

        return height;
    },

    showDetails: function () {
        const container = this.$el;
        const details = container.children('.shopping-cart-details');

        container.addClass('open');
        details.hide();

        if (app.getShoppingCart().get('shoppingCartItems').length > 0) {
            details.show();
        } else {
            container.addClass('empty');
        }
    },

    hideDetails: function () {
        const container = this.$el;
        const details = container.children('.shopping-cart-details');

        container.removeClass('empty');

        details.hide();
        container.removeClass('open');
    },

    onOrderClick: function () {
        if (window.POne.pageModel.userProfile.portalCustomer.customerRefNo) {
            this.customerOrderModal.modal('show');
        } else {
            window.location = `${window.POne.config.contextPath}/shopping_carts/${app.getShoppingCart().id}/submit?submitShoppingCart=1`;
        }
    },

    onModal: function () {
        $(document).ready(function () {
            const inputs = $('.modal').find('h1, input, button, [tabindex=0]')
                .filter(':visible');
            const firstInput = inputs.first();
            const lastInput = inputs.last();

            /*set focus on first input*/
            firstInput.focus();

            /*redirect last tab to first input*/
            lastInput.keydown(function (key) {
                if (key.which === 9) {
                    if (!key.shiftKey) {
                        key.preventDefault();
                        firstInput.focus();
                    }
                }
            });

            /*redirect first shift+tab to last input*/
            firstInput.keydown(function (key) {
                if (key.which === 9) {
                    if (key.shiftKey) {
                        key.preventDefault();
                        lastInput.focus();
                    }
                }
            });
        });
    },

    tabFocusShoppingCart: function () {
        if (app.getShoppingCart().get('shoppingCartItems').length > 0) {
            this.showDetails();
        }
    },

    tabBlurShoppingCart: function () {
        if (app.getShoppingCart().get('shoppingCartItems').length > 0) {
            this.hideDetails();
        }
    }
});



// WEBPACK FOOTER //
// ./views/shoppingCart/ShoppingCartElementController.js